import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faAngleDown, faAngleUp, faBars, faTimes,
} from '@fortawesome/free-solid-svg-icons';
import { Link, Script } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import './style.css';
import { ONELINK_SCRIPT_URL } from '../../configs/appsflyer';
import useSmartScript from '../../hooks/useSmartScript';
import SubNavItem from './SubNavItem';
import GTM_TRACKERS from '../../../constants/gtm-trackers';

const Navbar = ({ lang, white }) => {
  const [navbarOpen, setNavbarOpen] = useState(false);
  const [isPromoExpanded, setIsPromoExpanded] = useState(false);

  lang.toString();

  const { smartScriptUrl, setIsSmartScriptLoaded } = useSmartScript();

  return (
    <>
      <Script src={ONELINK_SCRIPT_URL} onLoad={() => { setIsSmartScriptLoaded(true); }} />
      <nav className="px-3 lg:px-24 flex items-center sticky top-0 z-50 bg-white py-2 lg:py-0">
        <div className="flex-1 flex-row-reverse lg:flex-row lg:flex-none bg-transparent relative flex lg:w-auto lg:static lg:block lg:justify-start">
          <Link
            className={`
              md:hidden bg-blue-light40 text-white mx-2 px-6 rounded-md items-center self-center text-sm py-2 h-9 cntgtm_main_depositobpr_mobile_download
            `}
            to={smartScriptUrl}
          >
            Download
          </Link>
          <div className="py-2 px-4 lg:px-0 z-1 w-full lg:w-auto">
            <Link to="/">
              <StaticImage
                src="../../images/LogoKomunal.jpg"
                alt="Komunal-Logo"
                className="w-36 h-auto"
                objectFit="contain"
                placeholder="none"
              />
            </Link>
          </div>
          <button
            aria-label="toggle-menu"
            className={`text-${white ? 'white' : 'white'} cursor-pointer text-xl z-30
                leading-none px-3 py-1 border-none
                rounded bg-transparent block lg:hidden outline-none focus:outline-none`}
            type="button"
            onClick={() => setNavbarOpen(!navbarOpen)}
          >
            {!navbarOpen && <FontAwesomeIcon icon={faBars} className="text-blue-light40" />}
            {navbarOpen && <FontAwesomeIcon icon={faTimes} className="text-blue-light40" />}
          </button>
        </div>
        <div className={`
            navbar-links
            ${navbarOpen ? 'flex' : 'hidden'} -mt-3 lg:-mt-0 lg:flex z-30 bg-white lg:bg-white flex-col items-start
          `}
        >
          <ul className="flex flex-col items-start h-screen lg:h-auto lg:px-0 lg:items-end lg:flex-row list-none lg:ml-auto">
            <li className="nav-item w-screen lg:w-auto max-w-sm px-4 py-4 lg:py-0 lg:px-0 md:max-w-3xl">
              <Link
                className="lg:px-4 py-2 w-auto lg:w-full flex items-center text-sm font-normal leading-snug text-blue
                lg:text-blue hover:opacity-75 border-bottom-gray"
                to="/"
                activeClassName="active-navbar"
              >
                <i className="fab fa-pinterest text-lg leading-lg text-blue opacity-75" />
                <span>Beranda</span>
              </Link>
            </li>
            <li className="nav-item w-screen lg:w-auto max-w-sm px-4 py-4 lg:py-0 lg:px-0 md:max-w-3xl">
              <Link
                // eslint-disable-next-line max-len
                className={`lg:px-4 py-2 w-auto lg:w-full flex items-center text-sm font-normal leading-snug text-blue lg:text-blue hover:opacity-75 border-bottom-gray ${GTM_TRACKERS.PELUANG.MAIN}`}
                to="/peluang-deposito/"
                activeClassName="active-navbar"
              >
                <i className="fab fa-pinterest text-lg leading-lg text-blue opacity-75" />
                <span>Peluang Deposito</span>
              </Link>
            </li>
            <li className="nav-item w-screen lg:w-auto max-w-sm px-4 py-4 lg:py-0 lg:px-0 md:max-w-3xl">
              <Link
                // eslint-disable-next-line max-len
                className={`lg:px-4 py-2 w-auto lg:w-full flex items-center text-sm font-normal leading-snug text-blue lg:text-blue hover:opacity-75 border-bottom-gray ${GTM_TRACKERS.KALKULATOR.MAIN}`}
                to="/kalkulator/"
                activeClassName="active-navbar"
              >
                <i className="fab fa-pinterest text-lg leading-lg text-blue opacity-75" />
                <span>Kalkulator</span>
              </Link>
            </li>
            <li className="nav-item w-screen lg:w-auto max-w-sm px-4 py-4 lg:py-0 lg:px-0 md:max-w-3xl hidden lg:block">
              <Link
                // eslint-disable-next-line max-len
                className={`lg:px-4 py-2 w-auto lg:w-full flex items-center text-sm font-normal leading-snug text-blue lg:text-blue hover:opacity-75 border-bottom-gray ${GTM_TRACKERS.PROMO.MAIN}`}
                to="/promo/"
                activeClassName="active-navbar"
              >
                <i className="fab fa-pinterest text-lg leading-lg text-blue opacity-75" />
                <span className="flex items-center">Promo <div className="new-badge ml-1">Baru</div></span>
              </Link>
            </li>
            <li className="nav-item w-screen lg:w-auto max-w-sm px-4 py-4 lg:py-0 lg:px-0 md:max-w-3xl lg:hidden">
              <div
                className="lg:px-4 py-2 w-auto lg:w-full flex items-center leading-snug hover:opacity-75 border-bottom-gray cursor-pointer"
                onClick={() => setIsPromoExpanded(!isPromoExpanded)}
                role="presentation"
              >
                <i className="fab fa-pinterest text-lg leading-lg text-blue opacity-75" />
                <div className="w-full flex flex-col gap-y-2">
                  <div className="flex items-center gap-x-2">
                    <span className="text-sm font-normal text-blue">Promo</span>
                    <div className="new-badge">Baru</div>
                    {isPromoExpanded ? (
                      <FontAwesomeIcon icon={faAngleUp} />
                    ) : (
                      <FontAwesomeIcon icon={faAngleDown} />
                    )}
                  </div>
                  {isPromoExpanded && (
                    <SubNavItem to="/referral">
                      <StaticImage
                        src="../../images/navbar/rocket.svg"
                        alt="Rocket"
                        objectFit="contain"
                      />
                      <span className="text-xs text-blue-dark300 font-medium">Ajak Teman Dapat Bonus</span>
                    </SubNavItem>
                  )}
                </div>
              </div>
            </li>
            <li className="nav-item w-screen lg:w-auto max-w-sm px-4 py-4 lg:py-0 lg:px-0 md:max-w-3xl">
              <Link
                // eslint-disable-next-line max-len
                className={`lg:px-4 py-2 w-auto lg:w-full flex items-center text-sm font-normal leading-snug text-blue lg:text-blue hover:opacity-75 border-bottom-gray ${GTM_TRACKERS.BLOG.MAIN}`}
                to="/blog/"
                activeClassName="active-navbar"
              >
                <i className="fab fa-pinterest text-lg leading-lg text-blue opacity-75" />
                <span>Blog</span>
              </Link>
            </li>
            <li className="nav-item w-screen lg:w-auto max-w-sm px-4 py-4 lg:py-0 lg:px-0 md:max-w-3xl">
              <Link
                // eslint-disable-next-line max-len
                className={`lg:px-4 py-2 w-auto lg:w-full flex items-center text-sm font-normal leading-snug text-blue lg:text-blue hover:opacity-75 border-bottom-gray ${GTM_TRACKERS.FAQ.MAIN}`}
                to="/faq/"
                activeClassName="active-navbar"
              >
                <i className="fab fa-pinterest text-lg leading-lg text-blue opacity-75 md:max-w-3xl" />
                <span>FAQ</span>
              </Link>
            </li>
            <li className="nav-item w-screen lg:w-auto max-w-sm px-4 py-4 lg:py-0 lg:px-0 md:max-w-3xl">
              <Link
                className="lg:px-4 py-2 w-auto lg:w-full flex items-center text-sm font-normal leading-snug text-blue
                lg:text-blue hover:opacity-75 border-bottom-gray"
                to="/hubungi-kami/"
                activeClassName="active-navbar"
              >
                <i className="fab fa-pinterest text-lg leading-lg text-blue opacity-75" />
                <span>Hubungi Kami</span>
              </Link>
            </li>
            <li className="nav-item w-screen lg:w-auto max-w-sm px-4 mt-5 lg:mt-0 lg:px-0 lg:mr-4 md:max-w-3xl">
              <Link
                // eslint-disable-next-line max-len
                className="bg-white text-blue-light40 border-blue-light40 text-sm justify-center py-2 px-4 rounded-md items-center flex cntgtm_main_depositobpr_masuk"
                to="https://user.depositobpr.id/signin"
              >
                <span>Masuk</span>
              </Link>
            </li>
            <li className="nav-item w-screen lg:w-auto max-w-sm px-4 mt-3 lg:mt-0 lg:px-0 md:max-w-3xl">
              <Link
                // eslint-disable-next-line max-len
                className="bg-blue-light40 text-white text-sm py-2 px-4 rounded-md justify-center items-center flex rounded-green cntgtm_main_depositobpr_daftar_sekarang"
                to="https://user.depositobpr.id/signup"
              >
                <span>Daftar</span>
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
};
Navbar.propTypes = {
  lang: PropTypes.string,
  white: PropTypes.bool,
};

Navbar.defaultProps = {
  lang: 'id',
  white: false,
};

export default Navbar;
